<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-boxes"></i> Penjualan Tembakau
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <button v-if="$can('create tebasan')" type="button" class="btn btn-primary" @click="addNew">
                        <i class="fas fa-plus-square"></i> Penjualan
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/penjualan-tembakaus"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="terbayar" slot-scope="props">
                            <span>{{ formatNumber(props.rowData.terbayar) }}</span>
                        </template>
                        <template slot="kekurangan" slot-scope="props">
                            <span>{{ props.rowData.kekurangan <= 0 ? '-' : formatNumber(props.rowData.kekurangan) }}</span>
                        </template>
                        <template slot="status" slot-scope="props">
                            <span v-if="props.rowData.status == 'Lunas'" class="badge badge-pill badge-success">{{ props.rowData.status }}</span>
                            <span v-else-if="props.rowData.status == 'Belum dibayar'" class="badge badge-pill badge-secondary">{{ props.rowData.status }}</span>
                            <span v-else class="badge badge-pill badge-warning">{{ props.rowData.status }}</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                            <button v-if="($can('edit penjualan tembakau') && isSameDay(props.rowData.created_at)) || isSuperAdmin" type="button" title="Edit" @click="edit(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button v-if="($can('pelunasan penjualan tembakau') && !props.rowData.is_selesai) || isSuperAdmin" type="button" title="Pelunasan" @click="pelunasan(props.rowData)" class="btn btn-link px-1"><i class="fas fa-comments-dollar"></i></button>
                            <button v-if="isSuperAdmin" type="button" title="Delete" @click="deleteItem(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="lg" :hide-header="true" :hide-footer="true">
            <edit-form :isEdit="isEdit" :value="currentPenjualan" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>

        <b-modal v-model="viewModal" size="lg" :hide-header="true" :hide-footer="true">
            <viewer :value="currentPenjualan" @saved="saved" @cancel="viewModal = false"></viewer>
		</b-modal>

        <b-modal v-model="pelunasanModal" size="lg" :hide-header="true" :hide-footer="true">
            <pelunasan-form :value="currentPenjualan" is-pelunasan @saved="saved" @cancel="pelunasanModal = false"></pelunasan-form>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import EditForm from './Form';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import Viewer from './Viewer';
import PelunasanForm from './Viewer';

export default {
    name: "penjualan-tembakau",

    components: {
        EditForm,
        SearchBar,
        Viewer,
        PelunasanForm,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentPenjualan: null,
            searchText: '',
            searchDate: '',
            searchStatus: '',
            searchGudangId: '',
            searchGradeId: '',
            viewModal: false,
            editModal: false,
            isEdit: false,
            pelunasanModal: false,
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'gudang.name',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'created_at',
                    title: 'Tanggal Penjualan',
                    sortField: 'created_at',
                    callback: 'formatDate',
                },
                {
                    name: 'pembeli',
                    title: 'Pembeli',
                    sortField: 'pembeli',
                },
                {
                    name: 'berat_akhir',
                    title: 'Berat Total (kg)',
                    sortField: 'berat_akhir',
                    callback: 'formatNumber',
                },
                {
                    name: 'total',
                    title: 'Harga Jual (Rp)',
                    sortField: 'total',
                    callback: 'formatNumber',
                },
                {
                    name: '__slot:terbayar',
                    title: 'Terbayar (Rp)',
                },
                {
                    name: '__slot:kekurangan',
                    title: 'Kekurangan (Rp)',
                    sortField: 'kekurangan',
                },
                {
                    name: '__slot:status',
                    title: 'Status',
                    sortField: 'kekurangan',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "created_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                status: this.searchStatus,
                gudang_id: this.searchGudangId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchStatus = search.searchStatus;
            this.searchGudangId = search.searchGudangId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchStatus = '';
            this.searchGudangId = '';
            this.refresh();
        },

        addNew() {
            this.isEdit = false;
            this.currentPenjualan = null;
            this.editModal = true;
        },

        edit(rowData) {
            this.isEdit = true;
            this.currentPenjualan = Object.assign({}, rowData);
            this.editModal = true;
        },

        pelunasan(rowData) {
            this.currentPenjualan = Object.assign({}, rowData);
            this.pelunasanModal = true;
        },

        view(rowData) {
            this.currentPenjualan = Object.assign({}, rowData);
            this.viewModal = true;
        },

        saved() {
            this.isEdit = false;
            this.currentPenjualan = null;
            this.editModal = false;
            this.pelunasanModal = false;
            this.refresh();
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/penjualan-tembakaus/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/penjualan-tembakaus/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
